/* The owner's own call to action on /search/:id — its rules. */

/* Owner-level roles from the backend IndComp.ROLE_CHOICES: CL = Claimer,
   AD = Admin. Editors and anyone else are not owners. Re-exported from the
   live module rather than restated, so the two cannot drift. */
export { OWNER_ROLES, isOwnerRole } from "../Profile/GetMembershipButton";

/* The viewer's links to companies, as the live banner reads them. */
export const individualLinks = (userInfo) =>
  userInfo?.individual?.[0]?.individual || [];

/* Transcribed: `companyArr.includes(id) && companyDet[0]?.claimed === true`.
 * Written as one lookup — the live version builds three parallel arrays and
 * indexes into them, which is the same question asked awkwardly.
 */
export const isClaimedCompanyForViewer = (userInfo, companyId) => {
  if (!companyId) return false;
  const link = individualLinks(userInfo).find(
    (entry) => entry?.companyID?.companyID === companyId
  );
  return link?.companyID?.claimed === true;
};

/* Transcribed from the live effect: the status of THIS company's outstanding "Verify Company" request, off the individual record. */
export const verificationRequestStatus = (individualData, companyId) => {
  const rows = individualData?.requestIndividual || [];
  let status;
  rows.forEach((row) => {
    if (
      row?.request_type === "Verify Company" &&
      row?.companyID?.companyID === companyId
    ) {
      status = row?.status;
    }
  });
  return status;
};

/* Which of the owner's states applies. */
export const ownerCtaKind = ({
  verifiedCompany,
  requestStatus,
  role,
  profileStatus,
  verifyRequested,
  isOwner,
}) => {
  if (verifiedCompany) return "verified";
  if (requestStatus === "pending") return "in-progress";
  if (requestStatus === "Modified") return "modified";

  if (!isOwner) return null;

  if (profileStatus === "member") {
    return verifyRequested ? "requested" : "get-verified";
  }
  if (profileStatus === "verified") return null;
  return "get-membership";
};

/* The wording, in one place so the component stays markup. Transcribed. */
export const OWNER_CTA_LABEL = {
  verified: "Verified",
  "in-progress": "Verification in progress",
  modified: "Modified changes verification in progress",
  requested: "Verification requested — in review",
  "get-verified": "Get Verified",
  "get-membership": "Get Membership",
};

/* Transcribed: an Editor cannot act on any of these, and the live screen greys
   the control rather than hiding it. */
export const ownerCtaDisabled = (role) => role === "ED";
